import styled from "styled-components";

export const StyledAdsSellersDropdownWrapper = styled.div`
    display: flex;
    width: 100%;

    .ads-sellers-dropdown {
        display: flex;
        width: 100%;
    }
`;
